import React, { useState } from 'react'
import logo from '../assets/logo.png'
import { Link } from 'react-router-dom'
import {FaTimes, FaBars} from 'react-icons/fa'

const Navbar = () => {
  const navItems = [
    {
      id: 2, 
      text: "PRAWO",
      to: "/prawo",
      type: "normal"
    },{
      id: 3, 
      text: "PERSONAL MEDIA",
      to: "/personalmedia",
      type: "normal"
    },{
      id: 1, 
      text: "O NAS",
      to: "/onas",
      type: "normal"
    },{
      id: 4, 
      text: "KREDYTY FIRMOWE",
      to: "/kredytyfirmowe",
      type: "drop"
    },{
      id: 5, 
      text: "KREDYTY HIPOTECZNE",
      to: "/kredytyhipoteczne",
      type: "drop"
    },{
      id: 6, 
      text: "POŻYCZKI UNIJNE",
      to: "/pozyczkiunijne",
      type: "drop"
    },{
      id: 7, 
      text: "LEASINGI",
      to: "/leasingi",
      type: "drop"
    },
  ]

  const [nav, setNav] = useState(false);

  const toggleNav = () => {
    setNav(!nav)
  };

  const [dropdown, setDropdown] = useState(false);

  const toggleDropdown = () => {
    setDropdown(!dropdown);
  };

  return (
    <div className='bg-white shadow-md fixed w-full !z-50'>
        <div className='flex mx-auto justify-between lg:px-10 items-center'>
        <Link to="/."><img src={logo} alt="logo" className='w-[130px] sm:w-[200px]'/></Link>
        <ul className='hidden lg:flex'>
              <li  onMouseEnter={toggleDropdown} onMouseLeave={toggleDropdown}>
                  <p className={dropdown ? "px-10 text-[#4C4C9B]" : "px-10"}>FINANSE</p>
                  <li className={dropdown ? 'absolute bg-white text-center px-3 pb-5' : 'hidden'}>
                  {navItems.map((item) => {
                  if(item.type === "drop")
                    return(
                      <li key={item.id} className='pt-5'>
                        <Link to={item.to}>
                          <p className='hover:scale-95 hover:text-[#4C4C9B] duration-500'>{item.text}</p>
                        </Link>
                      </li>
                    )
                    return null;
                  })}
                  </li>
              </li>
              {navItems.map((item) => {
                if(item.type !== "drop")
                return(
                  <li  key={item.id}>
                    <Link to={item.to}>
                      <p className='pr-10 hover:scale-95 hover:text-[#4C4C9B] duration-500'>{item.text}</p>
                    </Link>
                  </li>)
                  return null;
                })}
              <li className='pr-10'>
                <a href="https://www.facebook.com/people/Oniko-Expert-sp-z-oo/100086489706249/" target="_blank" rel="noreferrer"><p className='hover:scale-95 hover:text-blue-700 duration-500'>FACEBOOK</p></a>
              </li>
        </ul>
        <div className='lg:hidden pr-10'>
          <button onClick={toggleNav}>
              {nav ? <FaTimes size={20}/> : <FaBars size={20}/>}
          </button>
        </div>
        </div>
        
        <div className={nav ? 'h-screen w-full text-center pt-10 lg:hidden' : 'hidden'}>
          {navItems.map((item) =>(
            <Link to={item.to} onClick={toggleNav}>
              <p className='pt-5 text-xl'>{item.text}</p>
            </Link>
          ))}
          <div className='pt-5 text-[#4C4C9B]'>
          <a href="https://www.facebook.com/people/Oniko-Expert-sp-z-oo/100086489706249/" target="_blank" rel="noreferrer"
          className='text-xl'
          >FACEBOOK</a>
          </div>
        </div>
    </div>
  )
}

export default Navbar